/* eslint-disable react/no-danger */
import withErrorHandler from "component/design-system/withErrorHandler";
import { getThumbImage } from "../../../util/helper/getThumbImage";

function SiteJabberEachProduct(props: any) {
  const {
    category = {}, upc, partNumber, sku, description, manufacturer, price, thumbnail, productLines,
  } = props;
  const item_group = productLines?.length ? productLines[0] : partNumber;
  const id = upc || sku;
  const data = {
    id,
    item_group,
    title: description,
    vendor: manufacturer,
    price,
    images: [getThumbImage(thumbnail)],
    // ex: http://localhost:3000/titan-breaker-bar-tit-12049
    tags: [category?.tier0, category?.tier1, category?.tier2],
  };
  return (
    <script
      id="ProductJson-product-template"
      type="application/json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export default withErrorHandler(SiteJabberEachProduct);
